/**
 * Map domain-level notification types to Bootstrap Alert colors.
 */
const NotificationLevelColorMap = {
  ERROR: "danger"
};

export default NotificationLevelColorMap;
